import MediaQueryWatcher from '../shared/mediaquerywatcher';
import {small} from '../../../shared/breakpoints';

const imageManager = {
    _setImageControl: function(isLargeScreen, productClassViewModel, $imageControl) {
        if (this._activeControl) {
            this._activeControl.destroy();
        }

        if (!isLargeScreen) {
            import('./imagecontrolsmall').then(({default: ImageControlSmall}) => {
                this._activeControl = new ImageControlSmall($imageControl, productClassViewModel);
            });
        } else {
            import('./imagecontrollarge').then(({default: ImageControlLarge}) => {
                this._activeControl = new ImageControlLarge($imageControl, productClassViewModel);
            });
        }
    },
    init: function($imageControl, productClassViewModel) {
        if (!productClassViewModel) {
            throw new Error('imageController.init requires a viewmodel as a parameter.');
        }

        new MediaQueryWatcher(`screen and (min-width: ${small}px)`, matches => {
            this._setImageControl(matches, productClassViewModel, $imageControl);
        });
    }
};

export default imageManager;
